import Experiments from '@wix/wix-experiments';
import { IPlatformAPI } from '@wix/native-components-infra/dist/src/types/types';

import { Spec, SPECS_SCOPE } from '../specs';

export const fetchExperiments = async (
  baseUrl: string,
  siteOwnerId?: string,
  visitorId?: string,
): Promise<Experiments> => {
  const experiments = new Experiments({
    baseUrl,
    requestContext:
      visitorId && siteOwnerId
        ? { forSiteVisitors: { visitorId, siteOwnerId } }
        : undefined,
    scope: SPECS_SCOPE,
  });
  await experiments.ready();
  return experiments;
};

export const experimentsNames = {
  fluidLayoutEnabled: Spec.FluidLayout,
  productSortingEnabled: Spec.ProductsSorting,
  shorterSearchTermEnabled: Spec.ShorterSearchTerm,
};

export type ExperimentNames = typeof experimentsNames;

export type FeatureToggles = { [k in keyof ExperimentNames]: boolean };

export const getFeatureToggles = (experiments: Experiments): FeatureToggles => {
  return {
    fluidLayoutEnabled: experiments.enabled(Spec.FluidLayout),
    productSortingEnabled: experiments.enabled(Spec.ProductsSorting),
    shorterSearchTermEnabled: experiments.enabled(Spec.ShorterSearchTerm),
  };
};

export const loadAndParseFeatureToggles = async (
  baseUrl: string,
  platformAPIs: IPlatformAPI,
  errorLogger,
): Promise<FeatureToggles> => {
  try {
    return getFeatureToggles(
      await fetchExperiments(
        baseUrl,
        platformAPIs.bi?.ownerId,
        platformAPIs.bi?.visitorId,
      ),
    );
  } catch (ex) {
    errorLogger(ex);
    return {
      fluidLayoutEnabled: false,
      productSortingEnabled: false,
      shorterSearchTermEnabled: false,
    };
  }
};
